import React from "react";

const ReplyQuote = ({ replyTo, onDark = false }) => {
  if (!replyTo?.messageId && !replyTo?.preview) return null;

  return (
    <div className={`bc-reply-quote ${onDark ? "bc-reply-quote-dark" : ""}`}>
      <div className="bc-reply-quote-bar" />
      <div className="bc-reply-quote-body">
        <span className="bc-reply-quote-author">{replyTo.userName || "Unknown"}</span>
        <span className="bc-reply-quote-preview">{replyTo.preview || "Message unavailable"}</span>
      </div>
    </div>
  );
};

export default ReplyQuote;
